import { useEffect } from "react";

import { generatePath, Link, useHistory, useParams } from "react-router-dom";

import { useAlert } from "@/contexts/AlertContext";
import useHash from "@/hooks/useHash";
import { useUser } from "@/hooks/useUser";
import { ROUTES } from "@/routes_new";
import AllEarsTitle from "@components/AllEarsTitle";
import Container from "@components/Container";
import Rhythm from "@components/Rhythm";
import { Tabs } from "@components/Tabs";
import TextButton from "@components/TextButton";
import Typography from "@components/Typography";

import General from "./partials/General";
import GeneralLimited from "./partials/GeneralLimited";
import HiddenMentions from "./partials/HiddenMentions";

import styles from "./MentionSettingsView.module.css";

const TABS = {
  default: [
    {
      component: General,
      label: L.MENTION_SETTING_GENERAL,
      identifier: "general",
    },
    {
      component: HiddenMentions,
      label: L.MENTION_SETTING_HIDDEN_MENTIONS,
      identifier: "hidden-mentions",
    },
  ],
  static_report: [
    {
      component: GeneralLimited,
      label: L.MENTION_SETTING_GENERAL,
      identifier: "general",
    },
    {
      component: HiddenMentions,
      label: L.MENTION_SETTING_HIDDEN_MENTIONS,
      identifier: "hidden-mentions",
    },
  ],
};

const getTabs = (searchKind) => TABS?.[searchKind] || TABS.default;

const MentionSettingsView = () => {
  const history = useHistory();
  const hash = useHash();
  const { orgUuid, uuid } = useParams();
  const { alerts } = useAlert();
  const { data: user } = useUser();

  useEffect(() => {
    let mounted = true;
    if (mounted && user?.data?.ok && user?.data?.is_readonly) {
      history.push(
        generatePath(ROUTES.MENTION_DETAIL_ORGID, { uuid, orgUuid })
      );
    }
    return () => {
      mounted = false;
    };
  });

  if (!alerts) {
    return null;
  }

  const alert = alerts.find((a) => a.uuid === uuid);
  const tabs = getTabs(alert?.kind);
  const active = tabs?.findIndex((tab) => tab.identifier === hash);

  return (
    <>
      <AllEarsTitle
        title={`${L.MENTION_SETTING_SEARCH} - ${L.MENTION_SETTING_TITLE}`}
      />
      <Rhythm>
        <Container className={styles.root} fullWidth>
          <Typography
            margin="none"
            variant="h1"
            wordBreak
            data-testid="mentions-title"
          >
            {L.MENTION_SETTING_FOR}{" "}
            <TextButton
              component={Link}
              to={generatePath(ROUTES.MENTION_DETAIL_ORGID, { uuid, orgUuid })}
            >
              {alert?.title}
            </TextButton>
          </Typography>
        </Container>
      </Rhythm>
      <Rhythm>
        <Container fullWidth>
          {alert?.description && (
            <Typography className={styles.description}>
              {alert.description}
            </Typography>
          )}
          {tabs ? (
            <Tabs
              active={active > -1 ? active : 0}
              tabs={tabs}
              onChange={({ identifier }) => {
                history.replace({ hash: identifier });
              }}
            />
          ) : null}
        </Container>
      </Rhythm>
    </>
  );
};

export default MentionSettingsView;
